module.exports = __webpack_public_path__ + "img/3@3x.4415e89a.png";